export default __webpack_public_path__ + "static/media/head.256d9854.png";